import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import AppShell from "@/components/platform/AppShell";
import { PageTitle } from "@/components/platform/Badges";
import { BreachDashboard, IncidentRegister } from "@/components/breach/Home";
import { Exports, ReadinessConfig, Templates } from "@/components/breach/Config";
import { hasPerm, useBreachMeta } from "@/lib/incidents";

const TABS = [["dashboard", "Breach dashboard"], ["register", "Incident register"], ["reports", "Reports and exports"], ["templates", "Templates"], ["config", "Breach readiness configuration"]];

export default function BreachDesk() {
  const meta = useBreachMeta();
  const nav = useNavigate();
  const [params, setParams] = useSearchParams();
  const tab = params.get("tab") || "dashboard";
  return (
    <AppShell testId="breach-desk-page">
      <PageTitle eyebrow="Operational compliance" title="Breach Desk"
                 subtitle="Record, scope, respond to and evidence suspected personal-data breaches. People make every classification and reportability decision; nothing is submitted or sent automatically."
                 actions={hasPerm(meta?.my_permissions, "INCIDENT_CREATE") && <Button onClick={() => nav("/breach/new")} className="bg-[#008080] hover:bg-[#008080]/90" data-testid="report-incident-btn"><Plus className="w-4 h-4 mr-1" />Report incident</Button>} />
      <Tabs value={tab} onValueChange={(v) => setParams({ tab: v })} className="mt-6">
        <TabsList className="bg-white border border-slate-200 flex-wrap h-auto" data-testid="breach-tabs">
          {TABS.map(([k, l]) => <TabsTrigger key={k} value={k} data-testid={`btab-${k}`}>{l}</TabsTrigger>)}
        </TabsList>
        <TabsContent value="dashboard" className="mt-5"><BreachDashboard /></TabsContent>
        <TabsContent value="register" className="mt-5"><IncidentRegister meta={meta} /></TabsContent>
        <TabsContent value="reports" className="mt-5"><Exports meta={meta} /></TabsContent>
        <TabsContent value="templates" className="mt-5"><Templates meta={meta} /></TabsContent>
        <TabsContent value="config" className="mt-5"><ReadinessConfig meta={meta} /></TabsContent>
      </Tabs>
    </AppShell>
  );
}
